export default __webpack_public_path__ + "static/media/icon-copy.c64c119b.svg";